// removed by extract-text-webpack-plugin
module.exports = {"wrap-support-container":"wrap-support-container","item-support-container":"item-support-container","wrap-image-support-container":"wrap-image-support-container","image-support-container":"image-support-container","title-red":"title-red","img-link":"img-link","title-black":"title-black","title-link":"title-link","support-container-description":"support-container-description","support-container-link":"support-container-link","view-more":"view-more"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_SupportInfoContainer.scss
// module id = ./components/home/sub-view/_SupportInfoContainer.scss
// module chunks = 0